// src/components/icons/SvgIcon.jsx

import React from "react";
import { icons } from "./icons";

const SvgIcon = ({ name, size = 24, color = "currentColor", className = "", style = {} }) => {
  const IconSvg = icons[name];

  if (!IconSvg) {
    console.warn(`Icon "${name}" not found!`);
    return null;
  }

  // Clone the SVG element to inject accessibility/title and props so DOM shows the icon name
  const svgWithMeta = React.cloneElement(
    IconSvg,
    {
      role: "img",
      "aria-label": name,
      // ensure SVG scales to the requested size (some icons already set width/height)
      width: IconSvg.props.width || size,
      height: IconSvg.props.height || size,
      fill: IconSvg.props.fill || color,
    },
    // put a <title> as first child so inspector shows the icon name
    //[<title key="icon-title">{name}</title>, ...(React.Children.toArray(IconSvg.props.children))]
  );

  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        width: size,
        height: size,
        color,
        ...style,
      }}
    >
      {svgWithMeta}
    </span>
  );
};

export default SvgIcon;
